import { UseMutationOptions } from 'react-query';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';
import MutationKeys from './keys';
import { CommunicationType } from 'domains/content/types';

export type CreateSmsInput = {
    applicationsAccess: string;
    name: string;
    communicationType: CommunicationType;
    content: string;
    parentFolderId?: number;
};

const useCreateSms = (mutateOptions: UseMutationOptions<unknown, Error, CreateSmsInput>) =>
    useMutation<CreateSmsInput>(MutationKeys.CREATE_SMS, CuredApiPaths.SMS, mutateOptions);

export default useCreateSms;
